import type { SortingRule } from 'react-table';
import { Icon, icons } from './Icon';

type ColumnSortIndicatorProps = {
  // column is the identifier of the column for which the sort indicator is being rendered.
  column: string;
  // currentSortMode is the sort mode that's currently active for the table.
  currentSortMode: SortingRule;
};

const ColumnSortIndicator = ({ column, currentSortMode }: ColumnSortIndicatorProps) => {
  if (column !== currentSortMode.id) {
    return null;
  }

  return (
    <span className="margin-left-sm">
      {currentSortMode.desc && <Icon icon={icons.caretDown} />}
      {!currentSortMode.desc && <Icon icon={icons.caretUp} />}
    </span>
  );
};

export default ColumnSortIndicator;
